import classes from './ProfilePicSkeleton.module.css';

const ProfilePicSkeleton = () => {
    return (
        <div className={classes.ProfilePicSkeleton}></div>
    )
}

export default ProfilePicSkeleton;